
export class AppConfig {
    public static MODULE_ID: string = 'module_id';
    public static USER_TOKEN_KEY: string = 'user_token_key';
    public static USER_INFO_KEY: string = 'user_info_key';
}
